module.exports = __webpack_public_path__ + "img/戒台寺-九龙松（袁方-摄）.f786c6c1.jpg";